import { render } from "./minors.view.vue?vue&type=template&id=16deb008&scoped=true&ts=true"
import script from "./minors.view.vue?vue&type=script&lang=ts"
export * from "./minors.view.vue?vue&type=script&lang=ts"

import "./minors.view.vue?vue&type=style&index=0&id=16deb008&scoped=true&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16deb008"]])

export default __exports__